
define('app/dashboard/leagues/create/lgCreateApp',[
	'jquery',
	'underscore',
	'backbone',
	'known/knownUtil',
	'known/models/userModel',
	'known/models/leagueInstanceModel',
	'known/collections/leagueInstanceCollection',
	'known/collections/productCollection',
	'app/dashboard/leagues/create/views/lgCreateView',
	'module'
], function(
		$, 
		_, 
		Backbone,
		KnownUtil,
		UserModel,
		LeagueInstanceModel,
		LeagueInstanceCollection, 
		ProductCollection,
		LgCreateView, 
		module){
	var initialize = function(){
		var initialModels = KnownUtil.setupSideNav();
		var userModel = initialModels.userModel;
		var prodCollection = initialModels.prodCollection;
		var userLeagueCollection = initialModels.leagueCollection;
		
		var requestedProdConfigMapJSON = $.parseJSON(module.config().requestedProdConfigMapJSON);
		
		var lgCreateView = new LgCreateView({
			userModel: userModel, 
			prodCollection: prodCollection, 
			userLeagueCollection: userLeagueCollection,
			prodConfigMap: requestedProdConfigMapJSON});
		lgCreateView.render();
	};
	
	return {
		initialize: initialize
	};
});